import { createAnnotation } from "@pages/Article/components/ArticleParagraphElements/annotation/AnnotationFactory";
import { ArticleNonParagraphProps } from "@pages/Article/components/ArticleParagraphElements/utils/types";
import { cn } from "@util/helpers";
import parse, { DOMNode, domToReact, Element } from "html-react-parser";

/**
 * Renders a pull quote element in an article.
 * This component processes the body string to extract pull quotes and applies appropriate styles and classes.
 */
const PullQuote = ({
  bodyString,
  className,
  paragraphWidth,
}: ArticleNonParagraphProps) => {
  const transformPullQuote = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (!node || node.type !== "tag") return null;

    if (node.name === "p") {
      const el = node;
      const className = cn(
        "mb-0 font-public-sans text-xs font-semibold tracking-2% text-gray-750 md:text-base md:text-gray-850"
      );

      const annotation = createAnnotation({ className });

      return <>{annotation(el)}</>;
    }

    if (node.name === "blockquote") {
      const el = node;
      const children = el.children as DOMNode[];
      const className = "mb-4 font-lct text-4xl tracking-2% text-gray-850";

      const appendObject = {
        prepend: "“",
        append: "”",
      };

      const annoation = createAnnotation({ className, appendObject });

      return (
        <blockquote className="mb-1" data-testid="pull-quote-component-quote">
          {domToReact(children, {
            replace: annoation,
          })}
        </blockquote>
      );
    }

    return null;
  };

  const transformPullQuoteBody = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (!node || node.type !== "tag") return null;

    if (
      node.name === "div" &&
      node.attribs.class.includes("paragraph--type-sidebar-quotebox")
    ) {
      const el = node;
      const children = el.children as DOMNode[];

      return (
        <div
          data-testid="article-pull-quote-component"
          className={cn(className, paragraphWidth)}
        >
          <div className="mb-4 w-1/4 border-b border-gray-850 pb-3 md:pb-4"></div>

          {domToReact(children, {
            replace: transformPullQuote,
          })}

          <div className="mt-4 w-1/4 border-t border-gray-850 pb-3 md:pb-4"></div>
        </div>
      );
    }
  };

  return (
    <>
      {parse(bodyString, {
        replace: transformPullQuoteBody,
      })}
    </>
  );
};

export default PullQuote;
